import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { Tag } from "@/types/movies";
interface Props {
  tags: Tag[];
  className?: string;
}
export default function GenreTags(t0) {
  const $ = _c(5);
  const {
    tags,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  if (!tags?.length) {
    return null;
  }
  const t2 = `flex items-center overflow-x-auto hiddenScroll ${className}`;
  let t3;
  if ($[0] !== tags) {
    t3 = tags.map(_temp);
    $[0] = tags;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp(t, idx) {
  return <Link key={t?.uuid ?? idx} href={`/movie/tags/${t?.name_en}`} className="flex items-center flex-shrink-0 whitespace-nowrap text-[12px] md:text-md font-bold text-white transition-all duration-500 bg-gray-500 hover:bg-primary rounded-md me-2 px-2 py-1">{t?.name_fa}</Link>;
}